<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label class="digm-form-required">Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label class="digm-form-required">Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <div v-if="branch_validate">
                    <span class="error">The Branch field is required.</span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'cancel'">
          <form @submit.prevent="validateCancel('cancel')" data-vv-scope="cancel">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label class="digm-form-required">Member ID</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="custom-search-select">
                      <model-select @searchchange="searchMember" :options="optionsMember" class="border-bottom" name="member_id" v-validate="'required'" v-model="addData.member_id"></model-select>
                    </div>
                    <span class="error">{{ errors.first('wristband.member_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Phone Number</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.phone_number" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Email</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.email" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Membership Type</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.membership_last_buy_name" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Join Date</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.start_membership" type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Cancel Category</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="cancel_category" v-validate="'required'" v-model="addData.cancel_category_id">
                      <option :value="0">Please select</option>
                      <option v-for="item in dataCancelCategory" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('cancel.cancel_category_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Revenue</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select class="border-bottom" name="revenue" v-validate="'required'" v-model="addData.revenue" :value="totalPayment">
                      <option value="">Please select</option>
                      <option :value="0">IDR 0</option>
                      <option :value="300000">IDR 300.000</option>
                      <option :value="500000">IDR 500.000</option>
                      <option :value="666000">IDR 666.000</option>
                      <option :value="688000">IDR 688.000</option>
                      <option :value="825000">IDR 825.000</option>
                      <option :value="1000000">IDR 1.000.000</option>
                      <option :value="1100000">IDR 1.100.000</option>
                      <option :value="2000000">IDR 2.000.000</option>
                      <option :value="2500000">IDR 2.500.000</option>
                      <option :value="3000000">IDR 3.000.000</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('cancel.revenue') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>End Date</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="config" v-model="addData.effective_date" v-validate="'required'" name="event_date" class="w-100 border-bottom"></flat-pickr>
                    <span class="error">{{ errors.first('cancel.effective_date') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label class="digm-form-required">Detail Reason</label>
                  </b-col>
                  <b-col sm="9">
                    <!-- <b-form-input class="border-bottom" v-model="addData.detail_reason" type="text"></b-form-input> -->
                    <!-- <b-form-input class="border-bottom" v-model="addData.detail_reason" type="text" name="detail_reason" v-validate="'required'"></b-form-input>
                    <span class="error">{{ errors.first('freeze.detail_reason') }}</span> -->
                    <b-form-select class="border-bottom" name="detail_reason" v-validate="'required'" v-model="addData.detail_reason">
                      <option value="">Please select</option>
                      <option :value="'No Time'">No Time</option>
                      <option :value="'Facilities (no machine)'">Facilities (no machine)</option>
                      <option :value="'Move out of Town'">Move out of Town</option>
                      <option :value="'Pregnant'">Pregnant</option>
                      <option :value="'Job Matter'">Job Matter</option>
                      <option :value="'Price'">Price</option>
                      <option :value="'Competitor'">Move to Another Gym</option>
                      <option :value="'Spouse'">Spouse</option>
                      <option :value="'Service'">Service</option>
                      <option :value="'Healthy Problem'">Healthy Problem</option>
                      <option :value="'Transfer'">Transfer</option>
                      <option :value="'Study Matter'">Study Matter</option>
                      <option :value="'Convert to Term'">Convert to Term</option>
                      <option :value="'Finished term'">Finished term</option>
                      <option :value="'Terminate By System'">Terminate By System</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.detail_reason') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div class="digm-form-required">Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1" v-model="addData.payment_type_id_1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('cancel.payment_type_id_1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1" :disabled="[1,6, 9].includes(addData.payment_type_id_1)" name="paymentCard1" v-model="addData.payment_card_id_1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                        <div v-if="![1,9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount" v-model="amountPaymentCard1" v-bind="money2"></money>
                  <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                    <span class="error">The payment first amount field is required.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="payment_type_id_2" @change="changePaymentType2" v-model="addData.payment_type_id_2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{item.name}}</option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2" :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6" name="paymentCard2" v-model="addData.payment_card_id_2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{item.name}}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea v-validate="'required'" class="w-100" rows="5" v-model="addData.notes"></textarea>
                  <span class="error">{{ errors.first('cancel.notes') }}</span>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn-primary">Submit</button>
              <b-modal modal-class="modal-custom-form" hide-footer v-model="modalShow" centered title="Form">
                <div class="container-iframe mobile-responsive">
                  <iframe v-show="urlDoc" :srcdoc="urlDoc" class="w-100" frameborder="0"></iframe>
                  <div class="p-20 bg-white">
                    <div class="row justify-content-center">
                      <div class="col-md-6">
                        <div class="checkbox-part text-center">
                          <form data-vv-scope="submit-form">
                            <input type="checkbox" v-validate="'required'" id="agreeForm" name="checkbox_agree" v-model="checked" value=""><label for="agreeForm" class="font-13 font-300 ml-10 label-agree">Click here to indicate that you have read and agree to the terms presented in the Terms and Conditions agreement</label>
                            <div class="text-center mt-10 mb-5">
                              <span class="error color-red">{{ errors.first('submit-form.checkbox_agree') }}</span>
                            </div>
                          </form>
                        </div>
                        <div class="d-flex justify-content-center">
                          <button type="submit" @click.prevent="validateTick('submit-form')" class="btn-primary text-center mt-10">Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-modal>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import Mixin from '../../mixins/memberMixin'

export default {
  name: 'addCancel',
  components: {
    ModelSelect
  },
  mixins:[Mixin],
  data: function () {
    return {
      fullNameDetail: '',
      linkDataPrivy: '',
      errorMoney: 'The amount field is required!',
      dataMember: [],
      dataBranch: [],
      dataCancelCategory: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d',
        minDate: 'today'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'cancel',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      detailMember: {},
      detailCS: {},
      CSName: '',
      // modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      amountPaymentCard1: '',
      amountPaymentCard2: '',
      branch_validate: false,
      addData: {
        branch_id: null,
        member_id: null,
        customer_service_id: null,
        revenue: '',
        effective_date: moment(new Date()).format('YYYY-MM-DD'),
        detail_reason: '',
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: '',
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: '',
        notes: '',
        cancel_category_id: 0
      },
      addDataPrivy: {
        member_id: null,
        customer_id: null,
        branch_id: null,
        doc_name: 'cancellation_form.hbs'
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'extendPt', text: 'Extend PT' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ],
      optionsMember: [
        { value: null, text: 'Please select' }
      ],
      checked: false,
      checked2: false,
      dataAgree: {
        ticked_status: ''
      },
      dataGetUrlLead: {
        doc_name: 'cancellation_form.hbs',
        trx_id: ''
      },
      urlDoc: '',
      modalShow: false
    }
  },
  methods: {
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'grabAndGoGopay') {
        this.$router.push('/allForm/addgrabAndGoGopay')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    async changePaymentCard1 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2 (event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    changePaymentType1 (event) {
      if (event === 6) {
        this.addData.payment_card_id_1 = 1
      } else {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2 (event) {
      if (event === 6) {
        this.addData.payment_card_id_2 = 1
      } else {
        this.addData.payment_card_id_2 = null
      }
    },
    getMemberData (event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateTick (data1) {
      if (this.addData.detail_reason === '') {
        this.$toast.success('please fill in required fields!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return
      }

      if (this.addData.notes === '') {
        this.$toast.success('please fill in required fields!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        return
      }

      this.$validator.validateAll(data1).then(async result => {
        if (![1,9].includes(this.addData.payment_type_id_1) && this.addData.payment_card_id_1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if(result) {
          if(this.checked === true) {
            this.dataAgree.ticked_status = 1
          } else {
            this.dataAgree.ticked_status = 0
          }
          try{
            const agreeStatus = await axios.put('transaction/v1/transaction/tick_form_agreement/' + this.dataGetUrlLead.trx_id, this.dataAgree)
            // console.log('Success submit tick',agreeStatus.data)
            this.$router.push('/allForm')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          } catch(error) {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    validateCancel (event) {
      if (this.addData.cancel_category_id == 0) {
        this.$toast.success('please fill cancel category!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
      }

      this.$validator.validateAll(event).then((result) => {
        if (![1,9].includes(this.addData.payment_type_id_1) && this.addData.payment_card_id_1 == null) {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if(result) {
          this.addData.payment_amount_1 = this.amountPaymentCard1
          this.addData.payment_amount_2 = this.amountPaymentCard2
          axios.post('crm/v1/form_cancel/', this.addData).then(response => {
            // console.log('test', response)
            this.dataGetUrlLead.trx_id = response.data.data.trx_id
            axios.post('crm/v1/form_aggreement/html_generate/cancel', this.dataGetUrlLead).then(response => {
                  // console.log('test', response)
              this.urlDoc = response.data
              this.modalShow = true
              this.$toast.success('data saved successfully!', 'Success', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            }).catch(error => {
              // console.log('error', error)
              this.$toast.success('Error get data!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
              })
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.branch_validate = false
      this.getMember()
      // axios.get('fitness/v1/member/data_entry?branch_id=' + event).then(response => {
      //   this.dataMember = response.data.data.rows
      //   this.optionsMember = [
      //     { value: null, text: 'Please select' }
      //   ]
      //   for (var i = 0; i < this.dataMember.length; i++) {
      //     let memberBranchId
      //     if(!this.dataMember[i].branch_id) {
      //       memberBranchId = '(FT-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
      //     } else {
      //       memberBranchId = '(' + this.dataMember[i].branch.codename + '-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
      //     }
      //     var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
      //     this.optionsMember.push(dataComplete)
      //   }
      // }).catch(error => {
      //   console.log('error', error)
      // })

      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      this.getMember()
      // axios.get('fitness/v1/member/data_entry').then(response => {
      //   this.dataMember = response.data.data.rows
      //   for (var i = 0; i < this.dataMember.length; i++) {
      //     let memberBranchId
      //     if(!this.dataMember[i].branch_id) {
      //       memberBranchId = '(FT-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
      //     } else {
      //       memberBranchId = '(' + this.dataMember[i].branch.codename + '-' + this.dataMember[i].id + ') ' + this.dataMember[i].first_name + ' ' + this.dataMember[i].last_name
      //     }
      //     var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: this.dataMember[i].id, text: memberBranchId})
      //     this.optionsMember.push(dataComplete)
      //   }
      //   // console.log('test', response)
      // }).catch(error => {
      //   console.log('error', error)
      // })
      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
        this.itemsPaymentType = response.data.data.rows
        this.itemsPaymentType2 = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service/').then(response => {
        this.dataCS = response.data.data.rows
        // console.log('test', response)
        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter cs member
          this.dataCS = this.dataCS.filter(cs => cs.id == Auth.Session.get().paradigm_id)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter branch member
          this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/cancel_category').then(response => {
        this.dataCancelCategory = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if(document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i=0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete","off")
          }
        }
      }
    }
  },
  computed: {
    getMemberId: function() {
      return this.addData.member_id
    },
    totalPayment: function() {
      let calculatedTotal = this.addData.revenue
      this.amountPaymentCard1 = this.addData.revenue
      return calculatedTotal
    },
    paymentLeft: function() {
      if (String(this.amountPaymentCard1).length > String(this.addData.revenue).length) {
        // console.log('test')
        this.amountPaymentCard2 = 0
      } else {
        this.amountPaymentCard2 = this.addData.revenue - this.amountPaymentCard1
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2)
      }
    }
  },
  watch: {
    getMemberId () {
      axios.get('fitness/v1/member/' + this.addData.member_id).then(response => {
        this.detailMember = response.data.data
        this.fullNameDetail = response.data.data.first_name + ' ' + response.data.data.last_name
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.addData.customer_service_id = Auth.Session.get().paradigm_id

      this.getCSData(this.addData.customer_service_id)
    }
  }
}
</script>

<style>
</style>
